
import Icon from 'scripts/components/basic/Icon.vue';
import Modal from 'scripts/components/basic/Modal.vue';
import Tab from 'scripts/components/basic/Tab.vue';
import Tabs from 'scripts/components/basic/Tabs.vue';
import Accordion from 'scripts/components/basic/Accordion.vue';
import AccordionGroup from 'scripts/components/basic/AccordionGroup.vue';
import Toast from 'scripts/components/basic/Toast.vue';
import Carousel from 'scripts/components/basic/Carousel.vue';
import Slide from 'scripts/components/basic/Slide.vue';
import Hero from 'scripts/components/basic/Hero.vue';
import ThreeColumns from 'scripts/components/basic/ThreeColumns.vue';
import ColorScroller from 'scripts/components/basic/ColorScroller.vue';
import IoLazyLoad from 'scripts/components/basic/IoLazyLoad.vue'
import ReviewsCarousel from 'scripts/components/basic/ReviewsCarousel.vue';
import RoastCarousel from 'scripts/components/basic/RoastCarousel.vue';
import SubscriptionSteps from 'scripts/components/basic/SubscriptionSteps.vue';
import coffeeType from 'scripts/components/basic/coffeeType.vue';
import BeanGrind from 'scripts/components/basic/BeanGrind.vue';
import SizeQuantity from 'scripts/components/basic/SizeQuantity.vue';
import ScrollTo from 'scripts/components/basic/ScrollTo.vue';
import StoreTour from 'scripts/components/basic/StoreTour.vue';

import IconColumns from 'scripts/components/icon-columns/IconColumns.vue'
import IconColumn from 'scripts/components/icon-columns/IconColumn.vue'

import IconButton from 'scripts/components/buttons/IconButton.vue';
import IconLink from 'scripts/components/buttons/IconLink.vue';
import PrimaryButton from 'scripts/components/buttons/PrimaryButton.vue';
import SubmitButton from 'scripts/components/buttons/SubmitButton.vue';
import LinkButton from 'scripts/components/buttons/LinkButton.vue';

import TextInput from 'scripts/components/forms/TextInput.vue';
import EmailInput from 'scripts/components/forms/EmailInput.vue';
import SelectInput from 'scripts/components/forms/SelectInput.vue';
import SelectInputSort from 'scripts/components/forms/SelectInputSort.vue';
import CheckboxInput from 'scripts/components/forms/CheckboxInput.vue';
import RadioInputGroup from 'scripts/components/forms/RadioInputGroup.vue';
import ContactForm from 'scripts/components/forms/ContactForm.vue';

import Cart from 'scripts/components/cart/Cart.vue';
import Sidecart from 'scripts/components/cart/Sidecart.vue';

import Navbar from 'scripts/components/navigation/Navbar.vue';
import PromoBar from 'scripts/components/navigation/PromoBar.vue';

import SearchResults from 'scripts/components/product/SearchResults.vue';
import ProductTile from 'scripts/components/product/ProductTile.vue';
import ProductDisplay from 'scripts/components/product/ProductDisplay.vue';
import PopProductDisplay from 'scripts/components/product/PopProductDisplay.vue';
import ProductBottomLine from 'scripts/components/product/ProductBottomLine.vue';
import PopProductBottomLine from 'scripts/components/product/PopProductBottomLine.vue';
import ProductPrice from 'scripts/components/product/ProductPrice.vue';
import ProductRoast from 'scripts/components/product/ProductRoast.vue';
import ProductRelated from 'scripts/components/product/ProductRelated.vue'
import ProductSubscriptionTile from 'scripts/components/product/ProductSubscriptionTile.vue';

import CollectionGrid from 'scripts/components/collection/CollectionGrid.vue';
import CollectionCarousel from 'scripts/components/collection/CollectionCarousel.vue';

import VideoCarousel from 'scripts/components/video/VideoCarousel.vue';
import VideoModal from 'scripts/components/video/VideoModal.vue';
import VideoEmbed from 'scripts/components/video/VideoEmbed.vue';

import PrivacyBanner from 'scripts/components/privacy/PrivacyBanner.vue';

import KlaviyoForm from 'scripts/components/forms/KlaviyoForm.vue'

import AccountLogin from 'scripts/components/account/AccountLogin.vue';
import AccountForgotPassword from 'scripts/components/account/AccountForgotPassword.vue';
import AccountRegister from 'scripts/components/account/AccountRegister.vue';
import AccountNav from 'scripts/components/account/AccountNav.vue';
import AccountSavedAddress from 'scripts/components/account/AccountSavedAddress.vue';
import AccountNewAddress from 'scripts/components/account/AccountNewAddress.vue';
import AccountSelectNav from 'scripts/components/account/AccountSelectNav.vue';
import EmployeeDiscount from 'scripts/components/account/EmployeeDiscount.vue';
import Datepicker from 'vuejs-datepicker';
import Vuemoment from 'vue-moment';
import moment from 'moment';
/**
 * Deferred components
 *
 * These components will only load if they are rendered by markup. Use
 * for components that don't load on every page.
 *
 * i.e. below the fold components, landing page components, etc.
 */
// const AsyncComponent = () => import('scripts/components/category/AsyncComponent.vue')

export default {
  Icon,
  Modal,
  Tab,
  Tabs,
  Accordion,
  AccordionGroup,
  Toast,
  Carousel,
  Slide,
  ScrollTo,
  Hero,
  StoreTour,
  ThreeColumns,
  IoLazyLoad,
  IconColumns,
  IconColumn,
  IconButton,
  IconLink,
  PrimaryButton,
  SubmitButton,
  LinkButton,
  Cart,
  Sidecart,
  Navbar,
  PromoBar,
  ColorScroller,
  SearchResults,
  ProductTile,
  ProductDisplay,
  PopProductDisplay,
  PopProductBottomLine,
  ProductBottomLine,
  ProductPrice,
  ProductRoast,
  ProductRelated,
  ProductSubscriptionTile,
  CollectionGrid,
  CollectionCarousel,
  VideoCarousel,
  VideoModal,
  VideoEmbed,
  TextInput,
  EmailInput,
  SelectInput,
  SelectInputSort,
  CheckboxInput,
  RadioInputGroup,
  PrivacyBanner,
  ContactForm,
  KlaviyoForm,
  AccountLogin,
  AccountForgotPassword,
  AccountRegister,
  AccountNav,
  AccountNewAddress,
  AccountSavedAddress,
  AccountSelectNav,
  EmployeeDiscount,
  ReviewsCarousel,
  RoastCarousel,
  SubscriptionSteps,
  coffeeType,
  BeanGrind,
  SizeQuantity,
  Datepicker,
  moment,
  Vuemoment,
};
